import { render, staticRenderFns } from "./TableBluePlayerTransfers.vue?vue&type=template&id=5dc77bc2&"
import script from "./TableBluePlayerTransfers.vue?vue&type=script&lang=js&"
export * from "./TableBluePlayerTransfers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports